<template>
  <div class="upload-box">
    <!-- Hidden input -->
    <b-form-file
      ref="fileInput"
      class="d-none"
      multiple
      @change="onFileChange"
    />

    <!-- Upload Area -->
    <div
      class="upload-area"
      @click="openFile"
      @dragover.prevent
      @drop.prevent="handleDrop"
    >
      <div class="upload-content">
        <UploadIcon />

        <p class="upload-text">
          Click to upload or drag and drop
        </p>

        <small class="upload-subtext">
          SVG, PNG, JPG or GIF (max. 2MB)
        </small>
      </div>
    </div>

    <p
      v-if="errorMessage"
      class="text-danger mt-2"
    >
      {{ errorMessage }}
    </p>

    <!-- File List -->
    <div
      v-if="files.length"
      class="file-list"
    >
      <div
        v-for="(file, index) in files"
        :key="index"
        class="file-row"
      >
        <div class="flex items-center gap-2">
          <feather-icon
            icon="ImageIcon"
            class="mr-50 text-primary"
            size="18"
          />
          <span>{{ file.name }}</span>
        </div>

        <div class="actions">
          <b-progress
            v-if="file.progress < 100"
            :value="file.progress"
            max="100"
            class="progress-bar"
          />

          <button
            class="delete-btn"
            @click="removeFile(index)"
          >
            <feather-icon
              icon="Trash2Icon"
              class="mr-50"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormFile, BProgress } from 'bootstrap-vue'
import { UploadIcon } from 'vue-feather-icons'

export default {
  name: 'UploadFile',

  components: {
    BFormFile,
    BProgress,
    UploadIcon,
  },

  data() {
    return {
      files: [],
      errorMessage: '',
      maxFileSize: 2 * 1024 * 1024,
    }
  },

  methods: {
    openFile() {
      this.$refs.fileInput.$refs.input.click()
    },

    onFileChange(event) {
      const selectedFiles = Array.from(event.target.files)
      this.addFiles(selectedFiles)
    },

    handleDrop(event) {
      const droppedFiles = Array.from(event.dataTransfer.files)
      this.addFiles(droppedFiles)
    },

    addFiles(newFiles) {
      this.errorMessage = ''

      newFiles.forEach(file => {
        if (file.size > this.maxFileSize) {
          this.errorMessage = `File "${file.name}" exceeds the maximum size of 2MB.`
          return // Skip this file
        }

        const fileObj = {
          file,
          name: file.name,
          progress: 0,
        }

        this.files.push(fileObj)
        this.simulateUpload(fileObj)
      })

      // send all files to parent
      this.$emit(
        'files-selected',
        this.files.map(f => f.file),
      )
    },

    simulateUpload(fileObj) {
      const interval = setInterval(() => {
        if (fileObj.progress >= 100) {
          clearInterval(interval)
        } else {
          // eslint-disable-next-line no-param-reassign
          fileObj.progress += 10
        }
      }, 150)
    },

    removeFile(index) {
      this.files.splice(index, 1)
      this.errorMessage = ''

      // update parent
      this.$emit(
        'files-selected',
        this.files.map(f => f.file),
      )
    },
  },
}
</script>

<style scoped>
.upload-box {
  width: 100%;
}

.upload-area {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.file-list {
  margin-top: 15px;
}

.file-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #eee;
  border-radius: 6px;
  margin-bottom: 8px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.progress-bar {
  width: 120px;
}

.delete-btn {
  border: none;
  background: transparent;
  color: #94A3B8;
  font-size: 16px;
  cursor: pointer;
}
</style>
